module.exports = __webpack_public_path__ + "static/media/house-9.b33d99d1.jpg";